import React from "react";
import dayjs from "dayjs";
import "dayjs/locale/id";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FaServer, FaNetworkWired } from "react-icons/fa";
import Edit from "../action/Edit";
import Hapus from "../action/Hapus";

import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";

dayjs.locale("id");

const STATUS_MAP = {
  dicek: { bg: "bg-blue-100", text: "text-blue-800", border: "border-blue-200", label: "Dicek" },
  bermasalah: { bg: "bg-red-100", text: "text-red-800", border: "border-red-200", label: "Bermasalah" },
  selesai: { bg: "bg-green-100", text: "text-green-800", border: "border-green-200", label: "Selesai" },
};

function DataPerawatanIt({ rows, handleDelete, handleEdit, loading = false }) {
  const targetTemplate = (row) => {
    if (row.inventaris_id || row.inventaris_nama) {
      return (
        <div className="flex items-center gap-2">
          <div className="p-2 bg-indigo-100 rounded-lg">
            <FaServer className="text-indigo-600 w-3.5 h-3.5" />
          </div>
          <div>
            <p className="font-semibold text-gray-900 text-sm m-0">
              {row.inventaris_nama || row.aset_nama || "-"}
            </p>
            <p className="text-xs text-gray-500 m-0">
              Inv: {row.inventaris_kode || row.aset_kode || "-"}
              {row.inventaris_ruang || row.aset_lokasi
                ? ` · ${row.inventaris_ruang || row.aset_lokasi}`
                : ""}
            </p>
          </div>
        </div>
      );
    }
    if (row.aset_manual_nama) {
      return (
        <div className="flex items-center gap-2">
          <div className="p-2 bg-amber-100 rounded-lg">
            <FaServer className="text-amber-600 w-3.5 h-3.5" />
          </div>
          <div>
            <p className="font-semibold text-gray-900 text-sm m-0">
              {row.aset_manual_nama}
            </p>
            <p className="text-xs text-gray-500 m-0">
              Manual
              {row.aset_manual_lokasi ? ` · ${row.aset_manual_lokasi}` : ""}
            </p>
          </div>
        </div>
      );
    }
    if (row.nama_layanan) {
      return (
        <div className="flex items-center gap-2">
          <div className="p-2 bg-teal-100 rounded-lg">
            <FaNetworkWired className="text-teal-600 w-3.5 h-3.5" />
          </div>
          <div>
            <p className="font-semibold text-gray-900 text-sm m-0">
              {row.nama_layanan}
            </p>
            <p className="text-xs text-gray-500 m-0">{row.penyedia || "Layanan"}</p>
          </div>
        </div>
      );
    }
    return <span className="text-gray-400">-</span>;
  };

  const statusTemplate = (row) => {
    const s = STATUS_MAP[row.status] || {
      bg: "bg-gray-100",
      text: "text-gray-800",
      border: "border-gray-200",
      label: row.status || "-",
    };
    return (
      <span
        className={`px-2 py-1 text-xs font-medium rounded-full border ${s.bg} ${s.text} ${s.border}`}
      >
        {s.label}
      </span>
    );
  };

  const checklistTemplate = (row) => {
    const list = Array.isArray(row.checklist) ? row.checklist : [];
    if (!list.length) return <span className="text-gray-400">-</span>;
    const ok = list.filter((c) => c.status === "ok").length;
    return (
      <span className="text-sm text-gray-700">
        {ok}/{list.length} OK
      </span>
    );
  };

  const aksiTemplate = (row) => (
    <div className="flex items-center justify-center gap-2">
      <Edit id={row.id} handleEdit={handleEdit} />
      <Hapus id={row.id} handleDelete={handleDelete} />
    </div>
  );

  if (loading) {
    return (
      <div className="flex items-center justify-center h-72">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-2" />
          <p className="text-gray-600">Memuat data...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full">
      <DataTable
        value={rows}
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 25, 50]}
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Menampilkan {first} sampai {last} dari {totalRecords} data"
        emptyMessage="Tidak ada data perawatan IT"
        loading={loading}
        stripedRows
        showGridlines
        responsiveLayout="scroll"
        className="p-datatable-sm"
      >
        <Column
          field="tanggal"
          header="Tanggal"
          body={(r) =>
            r.tanggal ? dayjs(r.tanggal).format("DD MMM YYYY") : "-"
          }
          style={{ minWidth: "120px" }}
          sortable
        />
        <Column
          field="kategori_nama"
          header="Kategori"
          body={(r) => r.kategori_nama || "-"}
          style={{ minWidth: "140px" }}
          sortable
        />
        <Column
          header="Target"
          body={targetTemplate}
          style={{ minWidth: "220px" }}
        />
        <Column
          header="Checklist"
          body={checklistTemplate}
          style={{ minWidth: "100px" }}
        />
        <Column
          field="status"
          header="Status"
          body={statusTemplate}
          style={{ minWidth: "120px" }}
          sortable
        />
        <Column
          field="nama_petugas"
          header="Petugas"
          body={(r) => r.nama_petugas || "-"}
          style={{ minWidth: "140px" }}
          sortable
        />
        <Column
          header="Aksi"
          body={aksiTemplate}
          style={{ minWidth: "100px", textAlign: "center" }}
        />
      </DataTable>
    </div>
  );
}

export default DataPerawatanIt;
